import * as React from 'react'
import { useState } from 'react'
import PropTypes from 'prop-types'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { createTheme } from '@mui/material/styles'
import { AppProvider } from '@toolpad/core/AppProvider'
import { DashboardLayout } from '@toolpad/core/DashboardLayout'
import {
  AccountBox,
  Home,
  Logout,
  ShoppingCart,
  Login,
} from '@mui/icons-material'
import TocIcon from '@mui/icons-material/Toc'
import AddCommentIcon from '@mui/icons-material/AddComment'
import LocalFloristIcon from '@mui/icons-material/LocalFlorist'
import AirplanemodeActiveIcon from '@mui/icons-material/AirplanemodeActive'
import { useLocation, useNavigate } from 'react-router-dom'
import { PageContainer } from '@toolpad/core'
import NoPage from '../../pages/NoPage/NoPage'
import ProductsGrid from '../ProductGrid/ProductGrid'
import LoginForm from '../login/login'
import { isAuthenticated, PROJECT_NAME } from '../../config/config'
import api from '../../config/api'
import Cart from '../Cart/Cart'
import ProfileCard from '../ProfileCard/ProfileCard'
import CategoryGrid from '../CategoryGrid/CategoryGrid'
import PayloadGrid from '../PayloadGrid/PayloadGrid'
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs'
import HistoryIcon from '@mui/icons-material/History'
import OrderHistory from '../OrderHistory/OrderHustory'
import CalendarFeature from '../Calendar/Calendar'

// Компоненты для страниц
const Page1 = () => (
  <>
    <ProductsGrid></ProductsGrid>
  </>
)
const Page2 = () => <Typography variant="h4">Профиль</Typography>
const Page3 = () => <Typography variant="h4">Корзина</Typography>
const Page4 = () => <Typography variant="h4">Предзаказы</Typography>
const Page5 = () => <Typography variant="h4">Обратная связь</Typography>
const Page6 = () => <Typography variant="h4">Поставка 1</Typography>
const Page7 = () => <Typography variant="h4">Поставка 2</Typography>
const Page8 = () => <Typography variant="h4">Сорт 1</Typography>
const Page9 = () => <Typography variant="h4">Сорт 2</Typography>
const errorPage500 = () => <Typography variant="h3">Произошла </Typography>
const LoginPage = () => <LoginForm />

let NoAuthNavigation = [
  {
    kind: 'header',
    title: 'Главная',
  },
  {
    segment: '',
    title: 'Главная',
    icon: <Home />,
    element: <Page1 />,
  },
  {
    segment: 'login',
    title: 'Войти',
    icon: <Login />,
    element: <LoginPage />,
  },
]

let NAVIGATION = [
  {
    kind: 'header',
    title: 'Главная',
  },
  {
    segment: '',
    title: 'Главная',
    icon: <Home />,
    element: <Page1 />,
  },
  {
    segment: 'profile',
    title: 'Профиль',
    icon: <AccountBox />,
    element: (
      <>
        <Breadcrumbs
          items={[
            { title: 'Главная', url: '/' },
            { title: 'Профиль', url: '/profile' },
          ]}
        />{' '}
        <ProfileCard />
      </>
    ),
  },
  {
    segment: 'carts',
    title: 'История заказов',
    icon: <HistoryIcon />,
    element: (
      <>
        <Breadcrumbs
          items={[
            { title: 'Главная', url: '/' },
            { title: 'История заказов', url: '/carts' },
          ]}
        />{' '}
        <OrderHistory />
      </>
    ),
  },

  {
    segment: 'cart',
    title: 'Корзина',
    icon: <ShoppingCart />,
    element: (
      <>
        <Breadcrumbs
          items={[
            { title: 'Главная', url: '/' },
            { title: 'Корзина', url: '/cart' },
          ]}
        />
        <Cart />
      </>
    ),
  },
  {
    segment: 'page-3',
    title: 'Предзаказы',
    icon: <TocIcon />,
    element: (
      <>
        <Breadcrumbs
          items={[
            { title: 'Главная', url: '/' },
            { title: 'Предзаказы', url: '/page-3' },
          ]}
        />{' '}
        <CalendarFeature />{' '}
      </>
    ),
  },
  {
    segment: 'logout',
    title: 'Выйти',
    icon: <Logout />,
  },
]

if (!isAuthenticated()) NAVIGATION = NoAuthNavigation

console.log(isAuthenticated())

const defaultTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#3af94d',
    },
    secondary: {
      main: '#001339',
    },
    success: {
      main: '#00ff0a',
    },
  },
})

function AppProviderBasic(props) {
  const { window } = props
  const location = useLocation()
  const navigate = useNavigate()

  const [navigationMod, setNavigationMod] = useState(NAVIGATION)

  function DemoPageContent({ pathname }) {
    const ignorableListRoutes = ['special/route']
    console.log(pathname)
    const currentPage = navigationMod.find(
      (item) => item.segment === pathname.replace(/^\//, ''),
    )

    if (
      (!currentPage || !currentPage.element) &&
      !ignorableListRoutes.includes(pathname) &&
      !props?.children
    ) {
      return <NoPage message="Страница не найдена :-(" />
    }

    return currentPage?.element
  }

  DemoPageContent.propTypes = {
    pathname: PropTypes.string.isRequired,
  }
  async function updateSidebar() {
    const response = await api.get('API_FRONT/payloads/get-list/')
    let modedArr = [
      {
        kind: 'header',
        title: 'Поставки',
      },
    ]
    response.data.results.map((item, index) => {
      modedArr.push({
        segment: `payloads/${item.id}`,
        title: item.name,
        icon: <AirplanemodeActiveIcon />,
        element: <PayloadGrid payload_id={item.id} />,
      })
    })

    const responseCat = await api.get('API_FRONT/categories/get-list/')
    let modedArrCat = [
      {
        kind: 'header',
        title: 'Цветы',
      },
    ]
    responseCat.data.results.map((item, index) => {
      modedArrCat.push({
        segment: `categories/${item.id}`,
        title: item.name,
        icon: <LocalFloristIcon />,
        element: (
          <>
            <Breadcrumbs
              items={[
                { title: 'Главная', url: '/' },
                { title: 'Категория', url: '/' },
                { title: `${item.name}`, url: `categories/${item.id}` },
              ]}
            />
            <CategoryGrid category_id={item.id} />
          </>
        ),
      })
    })

    modedArr = modedArr.concat(modedArrCat)
    setNavigationMod(navigationMod.concat(modedArr))
  }

  React.useEffect(() => {
    updateSidebar()
  }, [])

  // Инициализируем pathname текущим путём
  const [pathname, setPathname] = React.useState(
    location.pathname.replace(/^\//, ''),
  )

  const router = React.useMemo(() => {
    return {
      pathname,
      searchParams: new URLSearchParams(location.search),
      navigate: (path) => {
        const newPath = String(path).replace(/^\//, '')
        setPathname(newPath)
        navigate(path)
      },
    }
  }, [pathname, navigate, location.search])

  // Синхронизируем состояние при изменении location
  React.useEffect(() => {
    setPathname(location.pathname.replace(/^\//, ''))
  }, [location.pathname])

  const demoWindow = window !== undefined ? window() : undefined

  return (
    <AppProvider
      branding={{ logo: '', title: PROJECT_NAME }}
      navigation={navigationMod}
      theme={defaultTheme}
      router={router}
      window={demoWindow}
    >
      <DashboardLayout>
        <PageContainer>
          <DemoPageContent pathname={pathname} />
          {props.children}
        </PageContainer>
      </DashboardLayout>
    </AppProvider>
  )
}
export default AppProviderBasic
